export default __webpack_public_path__ + "static/media/cyber-monday.c99e0424.svg";